import React, { useState } from "react";
import { motion, useMotionValue, useMotionTemplate } from "framer-motion";
import styles from "./CardSpotlight.module.css";

const CardSpotlight = ({ 
  children, 
  className = "", 
  radius = 350, 
  color = "rgba(14, 165, 233, 0.15)",
  style = {}
}) => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e) => {
    const { currentTarget, clientX, clientY } = e;
    const { left, top } = currentTarget.getBoundingClientRect();

    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  };

  return (
    <div
      className={`${styles.cardSpotlight} ${className}`}
      style={style}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <motion.div
        className={styles.spotlight}
        style={{
          background: useMotionTemplate`
            radial-gradient(
              ${radius}px circle at ${mouseX}px ${mouseY}px,
              ${color},
              transparent 80%
            )
          `,
          opacity: isHovered ? 1 : 0,
        }}
      />
      {children}
    </div>
  );
};

export default CardSpotlight;
